// extracted by mini-css-extract-plugin
module.exports = {"aside":"SideNavigation_aside__0x3sH","nav":"SideNavigation_nav__PYwJB","active":"SideNavigation_active__1eQvR","mobileNav":"SideNavigation_mobileNav__Fg3qm"};